import React, { useEffect, useState, useMemo } from "react";
import GenericTable from "../GenericTable/GenericTable";
import { useNavigate } from "react-router-dom";
import config from "../../../config";
import axios from "axios";
import { Box, CircularProgress, IconButton } from "@mui/material";

const formatValue = (value) =>
  value === null || value === undefined || value === "" ? "N/A" : value;

const FeedbackColumns = (navigate) => [
  { id: "store_name", label: "Store Name", render: (row) => formatValue(row.store_name) },
      // { id: "client_id", label: "Client ID", render: (row) => formatValue(row.client_id) },
  // { id: "chatbot_session_id", label: "Chatbot Session ID", render: (row) => formatValue(row.chatbot_session_id) },
  // { id: "customer_name", label: "Customer Name", render: (row) => formatValue(row.customer_name) },
  { id: "client_user_name", label: "Client User Name", render: (row) => formatValue(row.client_user_name) },
  { id: "remarks", label: "Feedback", render: (row) => formatValue(row.remarks) },
  { id: "created_date", label: "Created Date", render: (row) => formatValue(row.created_date) },
  { id: "resolution_status", label: "Status", render: (row) => formatValue(row.resolution_status) },
  // {
  //   id: "actions",
  //   label: "Actions",
  //   render: (row) => (
  //     <Box sx={{ display: "flex", gap: 1 }}>
  //       <IconButton
  //         size="small"
  //         onClick={() => navigate(`/chat-feedback/${row.chat_feedback_id}`)}
  //         sx={{ color: "#1976d2" }}
  //       >
  //         <i className="material-symbols-outlined" style={{ fontSize: 18 }}>
  //           visibility
  //         </i>
  //       </IconButton>
  //     </Box>
  //   ),
  // },
];

function ClientFeedbackList() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  // 🔥 Fetch API Data
  useEffect(() => {
    setLoading(true);
    axios
      .get(`${config.API_BASE_URL_V1}/admin/chat-feedback`)
      .then((response) => {
        const apiData = response.data.data || [];

        const formattedRows = apiData.map((item) => ({
          chat_feedback_id: item.chat_feedback_id,
          store_name: item.store_name,
          client_id: item.client_id,
          client_user_name: item.client_user_name,
          chatbot_session_id: item.chatbot_session_id,
          customer_name: item.customer_name,
          created_date: item.created_date,
          remarks: item.remarks,
          resolution_status: item.resolution_status,
        }));

        setRows(formattedRows);
      })
      .catch((error) => console.error("API Error:", error))
      .finally(() => setLoading(false));
  }, []);

  // Unique Store Values for Dropdown
  const storeValues = useMemo(
    () => [...new Set(rows.map((item) => item.store_name))],
    [rows]
  );

  // Static resolution values
  const resolutionValues = ["open", "closed", "resolved"];

  return (
    <>
      {/* ✅ LOADER - Show while data is loading */}
      {loading && (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "400px" }}>
          <CircularProgress />
        </Box>
      )}
      {/* ✅ TABLE - Show when data is loaded */}
      {!loading && (
        <GenericTable
          title=""
          columns={FeedbackColumns(navigate)}
          rows={rows}
          dropdownFilters={["store_name", "resolution_status"]}
          dropdownValues={{
            store_name: storeValues,
            resolution_status: resolutionValues,
          }}
          dateFilters={["created_date"]}
          showView={false}
          showEdit={false}
          showDelete={false}
        />
      )}
    </>
  );
}

export default ClientFeedbackList;


